import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconChevronUpDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M5.642 15.27a.75.75 0 0 0 1.06 0l5.47-5.47 5.47 5.47a.75.75 0 0 0 1.06-1.061l-6-6a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 0 0 0 1.06" clipRule="evenodd" /></svg></>;
}
export default IconChevronUpDefault;